import { apiClient } from './api';
import type {
  CardioExercise,
  CardioSession,
  CreateCardioSessionInput,
  ApiCollection,
} from './types';

export class CardioExerciseService {
  private static readonly ENDPOINT = '/api/cardio_exercises';

  static async getAll(): Promise<CardioExercise[]> {
    try {
      // API Platform генерира маршрути с underscore за CamelCase класове с underscore
      const endpoints = [
        '/api/cardio_exercises?pagination=false',           // underscore - правилния путь
        '/api/cardio-exercises?pagination=false',           // hyphen/kebab-case
      ];

      let lastError: Error | null = null;

      for (const endpoint of endpoints) {
        try {
          console.log('Trying cardio exercises endpoint:', endpoint);
          const response = await apiClient.get<ApiCollection<CardioExercise>>(endpoint);
          const data = response.data['member'] || response.data || [];
          if (Array.isArray(data)) {
            console.log(`✓ Successfully loaded cardio exercises from: ${endpoint} (${data.length} items)`);
            return data;
          }
        } catch (err) {
          lastError = err instanceof Error ? err : new Error(String(err));
          console.log(`✗ Failed endpoint: ${endpoint}`, err);
        }
      }

      // Если ничто не сработало, вернуть пустой массив с логом
      console.error('Could not load cardio exercises from any endpoint. Last error:', lastError);
      return [];
    } catch (error) {
      console.error('CardioExerciseService.getAll() error:', error);
      return [];
    }
  }

  static async getById(id: number): Promise<CardioExercise> {
    const response = await apiClient.get<CardioExercise>(`${this.ENDPOINT}/${id}`);
    return response.data;
  }
}

